module.exports = __webpack_public_path__ + "img/card-3.84c4b3d4.png";